module.exports = __webpack_public_path__ + "img/Card-Winners-HiRes.a59c9026.png";